module.exports = __webpack_public_path__ + "static/media/backWave24.a4ba6f39.svg";